import { render, staticRenderFns } from "./SpecialistLicenses.vue?vue&type=template&id=0b29b05a&"
import script from "./SpecialistLicenses.vue?vue&type=script&lang=js&"
export * from "./SpecialistLicenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports